<div class="layout-container">
  <div class="layout-main">
    <app-sidebar *ngIf="showSidebar" (menuItemSelected)="onMenuItemSelected($event)"></app-sidebar>

    <div class="main-content">
      <app-header
        *ngIf="showHeader"
        [breadcrumbs]="breadcrumbs()"
        [isHandset]="isHandset()"
        [showMenuSearch]="showSidebar"
        [showSupport]="showWenty"
        (breadcrumbClick)="onBreadcrumbClick($event)"
        (openSupport)="openSupportViaWenty()"
      ></app-header>

      <main class="page-content">
        <div class="content-wrapper">
          <router-outlet></router-outlet>
        </div>
      </main>
    </div>
  </div>

  <app-footer *ngIf="showFooter()"></app-footer>

  <app-wenty *ngIf="showWenty"></app-wenty>

  @if (showBirthdayCelebration()) {
    <app-birthday-celebration (dismissed)="onBirthdayCelebrationDismissed()" />
  }
</div>
